import { Type } from "class-transformer";

export abstract class AvailabilityModel {
	@Type(() => Date)
	public Discontinued: Date | null;
	public New: boolean;

	constructor(
		discontinued?: Date | null,
		New?: boolean) {
		if (discontinued)
			this.Discontinued = discontinued;
		if (New)
			this.New = New;
	}

	isDiscontinued(date?: Date): boolean {
		const today = date || new Date();
		return this.Discontinued != null && this.Discontinued <= today;
	}
}
